<section class="hero">
  <div class="wrapper">
    <h1 appGsapHeroIntro class="text-center assets-hero-title section-spacing">
      What is a CMDB?
      <span>Complete Guide for IT Teams</span>
    </h1>

    <p>
      A Configuration Management Database (CMDB) is a central system that keeps track of all the IT
      assets and components - known as Configuration Items (CIs) - within an organisation, along
      with how they relate to one another. By mapping the connections between infrastructure,
      applications, services, and users, a CMDB helps IT teams see the ripple effects of any change
      or outage before they happen.
    </p>

    <div class="hero-img flex justify-center">
      <div class="dashboard-wrapper">
        <img
          src="/assets/img/feature-imgs/assets/cmdb-dashboard.png"
          fetchpriority="high"
          alt="dashboard image"
          width="991"
          height="567.29"
          loading="eager"
        />
      </div>
    </div>
  </div>
</section>

<app-content-layout [config]="config" [accentColor]="accentColor" />

<app-modern-cta
  heading="Ready to Manage Your IT Assets?
Explore Infraon's ITAM Software"
  secondaryLabel="Start Your Free Trial"
  secondaryLink="/registration"
  [secondaryQueryParams]="{ type: 'trial', product: 'Infraon ITAM' }"
  [tags]="['Free Trail Available', 'Custom Demo', 'Live ROI Analysis']"
  bottomGlow="rgba(255, 147, 44, 0.12)"
/>
